import { SettingOutlined, TeamOutlined, InboxOutlined } from '@ant-design/icons';
import { OPERATIONS } from 'constants';

const settings = {
  id: 'settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'user_management',
      title: 'User Management',
      type: 'item',
      url: '/settings/user-management',
      icon: SettingOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    },
    {
      id: 'roles_and_permissions',
      title: 'Roles & Permissions',
      type: 'item',
      url: '/settings/roles-and-permissions',
      icon: TeamOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT]
    },
    {
      id: 'archived_items',
      title: 'Archived Items',
      type: 'item',
      url: '/archived-items',
      icon: InboxOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT]
    }
  ]
};

export default settings;
